/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Finish_BodyInputs */

const en_road_dude_steps_finish_body = /** @type {(inputs: Road_Dude_Steps_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the character and timing before sharing. If the words are hard to hear, add a short caption or your own voiceover.`)
};

const zh_road_dude_steps_finish_body = /** @type {(inputs: Road_Dude_Steps_Finish_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布前检查角色是否一致、停顿是否自然。如果对白不够清楚，可以补上短字幕或自己的配音。`)
};

/**
* | output |
* | --- |
* | "Check the character and timing before sharing. If the words are hard to hear, add a short caption or your own voiceover." |
*
* @param {Road_Dude_Steps_Finish_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_finish_body = /** @type {((inputs?: Road_Dude_Steps_Finish_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Finish_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_finish_body(inputs)
	return zh_road_dude_steps_finish_body(inputs)
});
export { road_dude_steps_finish_body as "road_dude.steps.finish.body" }